/**
 * MED-938 / E3.5 — colored month/day chip used by the session lists.
 * Green = today/live, amber = tomorrow, blue = further out.
 */
import { Box, Text } from '@mantine/core';

export type DateBlockTone = 'green' | 'amber' | 'blue';

const DATE_BLOCK_COLORS: Record<DateBlockTone, { bg: string; fg: string }> = {
  green: { bg: 'rgba(74, 124, 89, 0.12)', fg: '#4A7C59' },
  amber: { bg: 'rgba(233, 162, 59, 0.14)', fg: '#B97A12' },
  blue: { bg: 'rgba(45, 71, 57, 0.08)', fg: '#2D4739' },
};

export function DateBlock({ iso, tone }: { iso: string | null; tone: DateBlockTone }) {
  const colors = DATE_BLOCK_COLORS[tone];
  const d = iso ? new Date(iso) : null;
  const month = d ? d.toLocaleDateString('en-US', { month: 'short' }).toUpperCase() : '--';
  const day = d ? d.getDate() : '--';
  return (
    <Box
      style={{
        backgroundColor: colors.bg,
        borderRadius: 8,
        width: 48,
        minWidth: 48,
        textAlign: 'center',
        paddingTop: 4,
        paddingBottom: 4,
      }}
    >
      <Text fw={600} size="9px" tt="uppercase" c={colors.fg} style={{ letterSpacing: 0.3 }}>
        {month}
      </Text>
      <Text fw={700} size="md" c={colors.fg} lh={1.1}>
        {day}
      </Text>
    </Box>
  );
}
